// ----------------------------------------------------------------------------
// Component: Blog Posts
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Swiper
import Swiper from 'swiper';
import { Scrollbar, A11y, Keyboard } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/scrollbar';

// Scripts
import 'snippets/card/card';

// Styles
import './_blog-posts.scss';

// -------------------------------------
// Constants
// -------------------------------------
var CAROUSEL_SECTION_SELECTOR = '.section--blog-post';
var CAROUSEL_CLASS = 'carousel--blog-posts';
var CAROUSEL_SELECTOR = '.carousel--blog-posts';
var CAROUSEL_SCROLLBAR_SELECTOR = '.swiper-scrollbar';

// -------------------------------------
// Hooks
// -------------------------------------
document.querySelectorAll(CAROUSEL_SECTION_SELECTOR).forEach((element, index) => {
  // Generate unique class for each blog posts slider
  element.querySelector(CAROUSEL_SELECTOR).classList.add("".concat(CAROUSEL_CLASS, "-").concat(index));

  // Generate unique class for slider scrollbar
  element.querySelector(CAROUSEL_SCROLLBAR_SELECTOR).classList.add("".concat(CAROUSEL_CLASS, "-scrollbar-").concat(index));
  var swiper = new Swiper(".".concat(CAROUSEL_CLASS, "-").concat(index), {
    // Optional parameters
    modules: [Scrollbar, A11y, Keyboard],
    slidesPerView: 1.5,
    spaceBetween: 8,
    observer: true,
    observeParents: true,
    a11y: true,
    watchOverflow: true,
    // Do not turn into sliders if number of slides is less than slidesPerView.
    enabled: true,
    // Enable on mobile

    breakpoints: {
      // when window width is >= 768px - disable slider, use manual layout

      768: {
        slidesPerView: 2.5,
        enabled: true
      },
      1024: {
        enabled: false,
        spaceBetween: 8,
        slidesPerView: 4
      }
    },
    scrollbar: {
      el: ".".concat(CAROUSEL_CLASS, "-scrollbar-").concat(index),
      hide: false,
      draggable: true
    }
  });
  swiper.slides.forEach(function (slide, index) {
    var slideLink = slide.querySelector('a');
    if (slideLink) {
      slideLink.addEventListener('focus', function () {
        swiper.slideTo(index);
      });
    }
  });
});